import { render, staticRenderFns } from "./CandidateItemTab.vue?vue&type=template&id=023bc816&scoped=true&lang=pug"
import script from "./CandidateItemTab.vue?vue&type=script&lang=js"
export * from "./CandidateItemTab.vue?vue&type=script&lang=js"
import style0 from "./CandidateItemTab.vue?vue&type=style&index=0&id=023bc816&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023bc816",
  null
  
)

export default component.exports